import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PhoneField from "../PhoneField";
import { updateProfile, logout } from "../../actions/session";
import { Spinner, BrandButton } from "../../assets";
import { useHistory } from "react-router-dom";
// import VendorSignup from "./VendorSignup";

export default function AccountSummary() {

	const history = useHistory();
	const dispatch = useDispatch();
	const user = useSelector(state => state.session.user);
	const [changes, setChanges] = useState({});

	useEffect(() => {
		if (user && !user.loading)
			setChanges({});
	}, [user]);


	// Store object of values for display convenience.
	const values = {
		...user,
		...changes
	}

	function valueChange(name, value) {
		setChanges({
			...changes,
			[name]: value
		});
	}

	const canSubmit = Boolean(
		changes.tel ||
		changes.firstName ||
		changes.lastName
	)

	function inputChange(e) {
		valueChange(e.target.name, e.target.value);
	}

	return <>
		<section>
			<h4>Hi, {user.username}</h4>
			<div className="inner">
				Welcome to your <b>orderabl</b> account.
				<br /><br />
			</div>
		</section>

		<section>
			<div className="flexy" style={{ flexWrap: "wrap" }}>
				<section style={{ minWidth: "200px" }}>
					<h5>First name</h5>
					<div className="inner">
						<input type="text" name="firstName" value={values.firstName || ""} onChange={inputChange} />
					</div>
				</section>
				<section style={{ minWidth: "200px" }}>
					<h5>Last name</h5>
					<div className="inner">
						<input type="text" name="lastName" value={values.lastName || ""} onChange={inputChange} />
					</div>
				</section>
			</div>
		</section>

		<section>
			<h5>Telephone</h5>
			<div className="inner">
				<PhoneField
					value={values.tel}
					onChange={tel => valueChange("tel", tel)}
				/>
				<br />
			</div>
		</section>

		<section>
			<div className="inner">
				<button
					style={{ width: "100%" }}
					disabled={!canSubmit}
					onClick={e => {
						if (!canSubmit) return;
						dispatch(updateProfile(changes))
					}}
				>
					{user.loading ?
						<Spinner />
						:
						"Update My Details"
					}
				</button>
			</div>
		</section>

		{!Boolean(user.shop) && <section>
			<h4>Want to start selling online too?</h4>
			<div className="inner">
				Getting started on <b>ORDERABL+</b> is easy - press the button to set up a shop. It only takes a couple of minutes!
				<br /><br />
				<BrandButton className="brand-bg" onClick={e => history.push("/signup")}>Set Up Shop</BrandButton>
				{/* <VendorSignup /> */}
			</div>
		</section>}

		{/* Support */}
		<section>
			<h4>Having any issues, or want a hand?</h4>
			<div className="inner">
				Call, email or start a live chat session. We're here to help.
				<br /><br />
			</div>
			<div className="flexy inner" style={{ marginBottom: 10 }}>
				<a style={{ marginRight: 5 }} className="button" href="tel:01297678518">01296 678 518</a>
				<a style={{ marginLeft: 5 }} className="button" href="mailto:be@orderabl.com">be@orderabl.com</a>
			</div>
			<div className="inner">
				<BrandButton className="brand-bg" onClick={e => {
					if (window.HubSpotConversations)
						window.HubSpotConversations.widget.open();
				}}>Live chat</BrandButton>
			</div>
		</section>

		{/* Logout */}
		<section>
			<h4>All done here?</h4>
			<div className="inner">
				Feel free to leave your account signed in, unless you're on a shared computer.
				<br /><br />
				If you want to sign out at any time, click the button below.
				<br /><br />
			</div>
			<div className="inner">
				<BrandButton onClick={e => dispatch(logout())}>Log out</BrandButton>
			</div>
		</section>
	</>
}